import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { App, AppResolveData, ConfiguredApp } from '../interfaces/app';
import { AppsService } from '../services/apps/apps.service';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppResolver implements Resolve<App> {
  constructor(private appsService: AppsService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<App> {
    const chainId = Number(route.parent?.paramMap.get('id'));
    const appId = route.paramMap.get('appId') ?? '';

    return this.appsService.getAppById(chainId, appId);
  }
}
